import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getAlertById } from '../../services/AlertsService';
import { AlertDetails } from '../../types/Alerts';

function useGetAlertTypeById(id?: string, fleetId?: string): UseQueryResult<AlertDetails> {
  return useQuery(
    ['alert', id, fleetId],
    async (): Promise<AlertDetails> => getAlertById(id as string, fleetId as string),
    {
      retry: 0,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      enabled: !!id && !!fleetId,
    },
  );
}

export default useGetAlertTypeById;
